let dirPath = 'static/games/page016_game1';

let configGame = {
  removeInCorrects: true,
  correctBlock: false,
  //autoCheckAllCorrect: true,
  removeAllFromBadTarget: true,
  rulesGame: {
    itemsConfig: {
      block: true,
      shuffle: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 't01',
        idItem: 't01',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '20',
            correct: [{ idGroup: 't01', idItem: 't01' }],
          },
          {
            idGroup: 'source',
            idItem: '21',
            correct: [{ idGroup: 't01', idItem: 't01' }],
          },
          {
            idGroup: 'source',
            idItem: '22',
            correct: [{ idGroup: 't01', idItem: 't01' }],
          },
        ],
      },
      {
        idGroup: 't02',
        idItem: 't02',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '30',
            correct: [{ idGroup: 't02', idItem: 't02' }],
          },
          {
            idGroup: 'source',
            idItem: '31',
            correct: [{ idGroup: 't02', idItem: 't02' }],
          },
          {
            idGroup: 'source',
            idItem: '32',
            correct: [{ idGroup: 't02', idItem: 't02' }],
          },
          {
            idGroup: 'source',
            idItem: '33',
            correct: [{ idGroup: 't02', idItem: 't02' }],
          },
        ],
      },
      {
        idGroup: 't03',
        idItem: 't03',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '40',
            correct: [{ idGroup: 't03', idItem: 't03' }],
          },
          {
            idGroup: 'source',
            idItem: '41',
            correct: [{ idGroup: 't03', idItem: 't03' }],
          },
          {
            idGroup: 'source',
            idItem: '42',
            correct: [{ idGroup: 't03', idItem: 't03' }],
          },
          {
            idGroup: 'source',
            idItem: '43',
            correct: [{ idGroup: 't03', idItem: 't03' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: {
        margin: { left: 15, bottom: 5 },
      },
      background: {
        color: 'transparent',
        //color: 'rgba(0,0,0,0.3)',
        text: { textAlign: 'center', bold: true },
      },
    },
    groupsConfig: {
      positions: {
        pos: { y: 473, height: 344, width: 500 },
        rows: 1,
        margin: { left: 85 },
      },
    },
    groups: [
      {
        idGroup: 't01',
        background: {
          image: { src: dirPath + '/img/02.png' },
        },
        items: [
          {
            id: 't01',
            positions: { pos: { x: 180, y: 120, width: 110, height: 30 } },
          },
        ],
      },
      {
        idGroup: 't02',
        background: { image: { src: dirPath + '/img/00.png' } },
        items: [
          {
            id: 't02',
            positions: { pos: { x: 180, y: 120, width: 110, height: 30 } },
          },
        ],
      },
      {
        idGroup: 't03',
        background: { image: { src: dirPath + '/img/01.png', pos: { x: 24 } } },
        items: [
          {
            id: 't03',
            positions: { pos: { x: 180, y: 120, width: 110, height: 30 } },
          },
        ],
      },
      {
        idGroup: 'source',
        background: {
          color: 'transparent',
        },
        positions: {
          type: 'absolute',
          pos: { x: 280, y: 50 },
          autoFit: true,
        },
        itemsConfig: {
          positions: {
            pos: { height: 112, width: 163 },
            margin: { right: 50, top: 20 },
            rows: 2,
          },
        },
        items: [
          {
            id: '20',
            background: {
              image: { src: dirPath + '/img/20.png' },
            },
          },
          {
            id: '21',
            background: {
              image: { src: dirPath + '/img/21.png' },
            },
          },
          {
            id: '22',
            background: {
              image: { src: dirPath + '/img/22.png' },
            },
          },
          {
            id: '30',
            background: {
              image: { src: dirPath + '/img/30.png' },
            },
          },
          {
            id: '31',
            background: {
              image: { src: dirPath + '/img/31.png' },
            },
          },
          {
            id: '32',
            background: {
              image: { src: dirPath + '/img/32.png' },
            },
          },
          {
            id: '33',
            background: {
              image: { src: dirPath + '/img/34.png' },
            },
          },
          {
            id: '40',
            background: {
              image: { src: dirPath + '/img/40.png' },
            },
          },
          {
            id: '41',
            background: {
              image: { src: dirPath + '/img/41.png' },
            },
          },
          {
            id: '42',
            background: {
              image: { src: dirPath + '/img/42.png' },
            },
          },
          {
            id: '43',
            background: {
              image: { src: dirPath + '/img/43.png' },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  // isDev: true,
  //   defaultConfig: dirPath + '/defaultConfig.json',
  //   realHeight: 790,
  //   realWidth: 1820,
  // mainImage: {
  //   imagePath: dirPath + '/img/bgr.png',
  //   pos: {
  //     y: -100,
  //     x: 80,
  //   },
  //   cssStyle: {
  //     positions: 'absolute',
  //     left: '-46px',
  //     top: '30px',
  //   },
  // },
  mainImage: {
    imagePath: dirPath + '/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  configGame: configGame,
};

export default dataConfig;
